export const MCollectionPath = '/m-collection';
export const MCollectionTypePath = '/m-collection-type';
export const MCollectionPagePath = MCollectionPath + '/:productTypeSlug?';
export const MCollectionTypePagePath = MCollectionTypePath + '/:productTypeSlug?';